import React from 'react';
import AccountCircleOutlined from '@material-ui/icons/AccountCircleOutlined';

export default function AccountCircleOutlinedIcon() {

    return (
        <AccountCircleOutlined />
    );
};